import { render, staticRenderFns } from "./editor-form.vue?vue&type=template&id=5c1b5418&"
import script from "./editor-form.vue?vue&type=script&lang=js&"
export * from "./editor-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports